/* External dependencies */
import { filter, switchMap } from 'rxjs/operators';

/* Local dependencies */
import { getClient } from '../../../../../clients/client';
import { updateProfileError, updateProfileSuccess } from './action';
import { updateProfileMutation } from './mutation';
import { UpdateProfileActionTypes, UpdateProfileInput, UpdateProfileRequest } from './types';

export default function updateProfileEpic(action$) {
  return action$.pipe(
    filter((action: UpdateProfileRequest) => action.type === UpdateProfileActionTypes.UPDATE_PROFILE_REQUEST),
    switchMap((action: UpdateProfileRequest) =>
      requestUpdateProfile(action.input).then(updateProfileSuccess).catch(updateProfileError),
    ),
  );
}

async function requestUpdateProfile(input: UpdateProfileInput): Promise<unknown> {
  const graphQLClient = await getClient();
  const mutation = { mutation: updateProfileMutation, variables: { input } };

  const {
    data: { updateUser },
  } = await graphQLClient.mutate(mutation);

  return updateUser;
}
